import { useEffect, useState } from "react";
import { EVENT_DATE_ISO } from "@/constants/testIds";

function diff(target) {
  const now = Date.now();
  const t = new Date(target).getTime();
  const ms = Math.max(0, t - now);
  const days = Math.floor(ms / (1000 * 60 * 60 * 24));
  const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((ms / (1000 * 60)) % 60);
  const seconds = Math.floor((ms / 1000) % 60);
  return { days, hours, minutes, seconds, done: ms === 0 };
}

export default function CountdownTimer({ target = EVENT_DATE_ISO, variant = "light" }) {
  const [t, setT] = useState(() => diff(target));
  useEffect(() => {
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const cell = (n, label) => (
    <div className="text-center px-3 md:px-5">
      <div
        className={`font-display leading-none text-4xl md:text-6xl ${
          variant === "dark" ? "text-cream" : "text-forest"
        }`}
      >
        {String(n).padStart(2, "0")}
      </div>
      <div
        className={`eyebrow mt-2 ${
          variant === "dark" ? "text-cream/60" : "text-forest/60"
        }`}
      >
        {label}
      </div>
    </div>
  );

  return (
    <div
      className={`inline-flex items-stretch divide-x ${
        variant === "dark" ? "divide-cream/20" : "divide-forest/20"
      }`}
    >
      {cell(t.days, "Days")}
      {cell(t.hours, "Hours")}
      {cell(t.minutes, "Minutes")}
      {cell(t.seconds, "Seconds")}
    </div>
  );
}
